'use client';

import React from 'react';
import ImageOnlySecondSlider, {ImageSliderSecondProps} from 'components/commercetools-ui/organisms/content/follow-us-slider';
import { TasticProps } from 'frontastic/tastics/types';


const ImageOnlySliderSecondTastic  = ({ data }: TasticProps<ImageSliderSecondProps>) => {
  return <ImageOnlySecondSlider data={data?.data?.dataSource} title={data.title}  />;
};

export default ImageOnlySliderSecondTastic;